import { PARCEIROS_FAQ } from './parceirosPublicCopy'

export function ParceirosPublicFaq() {
  return (
    <section id='duvidas' className='grid gap-4'>
      <div className='grid gap-2'>
        <p className='text-[11px] font-medium uppercase tracking-[0.28em] text-white/55'>Dúvidas</p>
        <h2 className='text-2xl font-black'>Perguntas frequentes</h2>
      </div>
      <div className='grid gap-2'>
        {PARCEIROS_FAQ.map((item) => (
          <details
            key={item.pergunta}
            className='group rounded-2xl border border-white/10 bg-white/[0.04] backdrop-blur-xl open:bg-white/[0.06]'
          >
            <summary className='cursor-pointer list-none px-4 py-3 font-medium text-white [&::-webkit-details-marker]:hidden'>
              <span className='flex items-center justify-between gap-4'>
                {item.pergunta}
                <span className='text-[#ff8fbd] group-open:rotate-45' aria-hidden>
                  +
                </span>
              </span>
            </summary>
            <p className='px-4 pb-4 text-sm leading-6 text-white/65'>{item.resposta}</p>
          </details>
        ))}
      </div>
    </section>
  )
}
